module.exports = __webpack_public_path__ + "img/tn.08334106.svg";